module.exports = __webpack_public_path__ + "static/media/clinic-medical.6ce26300.svg";